import React from 'react';
import { DataType, ObjectType } from '../../types/metadata';
import { Type, ToggleLeft, List, DollarSign, Calendar, Mail, Phone } from 'lucide-react';
interface BadgeProps {
  children: React.ReactNode;
  variant?: 'active' | 'inactive' | 'required' | 'conditional' | 'default';
  icon?: React.ReactNode;
  className?: string;
}
export function Badge({
  children,
  variant = 'default',
  icon,
  className = ''
}: BadgeProps) {
  const variants = {
    active: 'bg-green-100 text-green-800 border-green-200',
    inactive: 'bg-gray-100 text-gray-800 border-gray-200',
    required: 'bg-red-100 text-red-800 border-red-200',
    conditional: 'bg-amber-100 text-amber-800 border-amber-200',
    default: 'bg-blue-50 text-blue-700 border-blue-200'
  };
  return <span className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-medium border ${variants[variant]} ${className}`} data-id="element-431">
      {icon && <span className="w-3.5 h-3.5 flex items-center justify-center" data-id="element-432">
          {icon}
        </span>}
      {children}
    </span>;
}
export function ObjectTypeBadge({
  type
}: {
  type: ObjectType;
}) {
  const colors = {
    [ObjectType.Lead]: 'bg-blue-100 text-blue-800 border-blue-200',
    [ObjectType.Account]: 'bg-purple-100 text-purple-800 border-purple-200',
    [ObjectType.Opportunity]: 'bg-emerald-100 text-emerald-800 border-emerald-200'
  };
  return <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${colors[type]}`} data-id="element-433">
      {type}
    </span>;
}
export function DataTypeBadge({
  type
}: {
  type: DataType;
}) {
  const config = {
    [DataType.Text]: {
      icon: <Type className="w-3 h-3" data-id="element-434" />,
      label: 'Text'
    },
    [DataType.YesNo]: {
      icon: <ToggleLeft className="w-3 h-3" data-id="element-435" />,
      label: 'Yes/No'
    },
    [DataType.Picklist]: {
      icon: <List className="w-3 h-3" data-id="element-436" />,
      label: 'Picklist'
    },
    [DataType.Currency]: {
      icon: <DollarSign className="w-3 h-3" data-id="element-437" />,
      label: 'Currency'
    },
    [DataType.Date]: {
      icon: <Calendar className="w-3 h-3" data-id="element-438" />,
      label: 'Date'
    },
    [DataType.Email]: {
      icon: <Mail className="w-3 h-3" data-id="element-439" />,
      label: 'Email'
    },
    [DataType.Phone]: {
      icon: <Phone className="w-3 h-3" data-id="element-440" />,
      label: 'Phone'
    }
  };
  const {
    icon,
    label
  } = config[type];
  return <span className="inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-medium bg-slate-100 text-slate-700 border border-slate-200" data-id="element-441">
      {icon}
      {label}
    </span>;
}